import { render, staticRenderFns } from "./CreatePlaceholder.vue?vue&type=template&id=5753ea2e&scoped=true"
import script from "./CreatePlaceholder.vue?vue&type=script&lang=js"
export * from "./CreatePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./CreatePlaceholder.vue?vue&type=style&index=0&id=5753ea2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5753ea2e",
  null
  
)

export default component.exports